import React from "react";
import UIComponent from "components/UiComponent";
import MsgBox from "sis_ui/modules/notifications";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWindowClose } from "@fortawesome/free-solid-svg-icons/faWindowClose";
import { getIconAndColor } from "../components/EvaluationButtons";
import evaluationsConfig from "../../../moduleConfig";
import config from "root/../config";
import { useTranslation } from "react-i18next";
import { withRouter } from "components/Routing";

const CommentButtons = ({
  getUserForm,
  onClickHandler,
  selectedWorkflowRuleId,
  selectedActionCode,
  router,
}) => {
  const { navigate} = router;
  let setButtonsState = () => {};
  const { t } = useTranslation();

  const _submitEvaluationFormCallback = (setError) => {
    return (result) => {
      if (result.body) {
        if (result.body.STATUS == "success") {
          MsgBox.drawMessage(result.body.STATUS, result.body.MESSAGE);
          window.localStorage.setItem("evaluations-list-igonre-cache", true);
          if(selectedActionCode != 'SAVE') {
            navigate("/" + evaluationsConfig.map.EVALUATIONS_LIST.path);
          }
          getUserForm();
        }

        if (result.body.STATUS == "error") {
          result.body.MESSAGE.forEach((item, i) => {
            if (item.TAG == "") {
              MsgBox.drawMessage(result.body.STATUS, result.body.MESSAGE);
            } else {
              setError(item.TAG, item.MESSAGE);
            }
          });
        }
      } else {
        MsgBox.drawMessage(
          "error",
          t(
            "lbl.ERROR_PROCESSING_REQUEST",
            "There was an error processing your request"
          )
        );
      }
      onClickHandler({ hasComment: false });
      setButtonsState("active");
    };
  };
  const getButtons = (setError, values, submitForm) => {
    let components = [];
    let { icon, color } = getIconAndColor(selectedActionCode);

    components.push(
      <UIComponent
        id="cancelForm"
        name="cancelForm"
        key="cancelFormComment"
        className="color-blue btn__no-border"
        component="smart-button"
        title={t("lbl.CANCEL", "Cancel")}
        iconComponent={
          <FontAwesomeIcon icon={faWindowClose} size={"1x"} />
        }
        onClick={(event) => {
          onClickHandler({ hasComment: false });
        }}
        triggeredText={t("lbl.CANCELING", "Canceling...")}
      >
        {" "}
        {t("lbl.CANCEL", "Cancel")}
      </UIComponent>
    );
    components.push(
      <UIComponent
        id="sendEvaluationForm"
        name="sendEvaluationForm"
        key="sendEvaluationForm"
        className={`${color} btn__no-border save-btn-active`}
        component="smart-button"
        title={t(`btn.${selectedActionCode}`, selectedActionCode)}
        iconComponent={<FontAwesomeIcon icon={icon} size={"1x"} />}
        onClick={(event) => {
          submitForm(
            {
              action:
                config.apiAppUrl +
                evaluationsConfig.APIs.executeEvaluationWorkflow +
                "/" +
                selectedWorkflowRuleId,
              method: "POST",
            },
            _submitEvaluationFormCallback(setError, values)
          );
        }}
        triggeredText={t("lbl.SENDING", "Sending...")}
      >
        {" "}
        {t(`btn.${selectedActionCode}`, selectedActionCode)}
      </UIComponent>
    );

    return components;
  };
  return (
    <UIComponent component="smart-form-consumer">
      {({ setError, values, submitForm }) => (
        <UIComponent
          component="button-group"
          id="form-buttons"
          class={"btn-group"}
          getPublicData={(data) => {
            setButtonsState = data.setButtonGroupState;
          }}
          displayType="dropdown"
          dropUp
          compact={true}
          groupClass="bg-blue color-white btn__no-border"
        >
          {getButtons(setError, values, submitForm)}
        </UIComponent>
      )}
    </UIComponent>
  );
};

export default withRouter(CommentButtons);
